import * as ActionTypes from '../constants/actionTypes'
import { roleGetButtonMenu, roleUpdateButtonMenu } from '../api/role'

export const editButtonMenuForm = formFieldsChange => ({
  type: ActionTypes.ROLEBUTTONMENUFORM_EDITFORM_CHANGE,
  field: formFieldsChange,
})

export const reset = () => ({
  type: ActionTypes.ROLEBUTTONMENUFORM_ENTER_RESET,
})

export const fetchItems = values => (dispatch) => {
  dispatch({ type: ActionTypes.ROLEBUTTONMENUFORM_FETCHITEMS_LOAD })

  roleGetButtonMenu(values).then((res) => {
    const items = res.result

    dispatch({
      type: ActionTypes.ROLEBUTTONMENUFORM_FETCHITEMS_SUCCEED,
      items,
    })
    dispatch({
      type: ActionTypes.ROLEBUTTONMENUFORM_EDITFORM_CHANGE,
      fields: items,
      field: {
        idnum: { name: 'idnum', value: items[0].idnum },
        n_enable: { name: 'n_enable', value: !!items[0].n_enable },
        f_button: { name: 'f_button', value: items[0].f_button },
        f_role: { name: 'f_role', value: items[0].f_role },
      },
    })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.ROLEBUTTONMENUFORM_FETCHITEMS_FAIL,
      fetchButtonMenuItemsError: 'Ошибка получения данных элементам меню.',
    })
  })
}

export const editItem = values => (dispatch) => {
  dispatch({ type: ActionTypes.ROLEBUTTONMENUFORM_EDITITEM_LOAD })

  roleUpdateButtonMenu(values).then(() => {
    dispatch({ type: ActionTypes.ROLEBUTTONMENUFORM_EDITITEM_SUCCEED })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.ROLEBUTTONMENUFORM_EDITITEM_FAIL,
      editButtonMenuItemError: 'Ошибка изменения данных.',
    })
  })
}



// WEBPACK FOOTER //
// src/actions/roleButtonMenuForm.js